var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"label label-warning d-inline-block mr-2 pl-2 pr-2 mb-0"},[_vm._v(" Up to "),_c('strong',[_vm._v(_vm._s(_vm.numberImageThreshold))]),_vm._v(" images ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }